import Grid from "@mui/material/Grid";
import React, {useCallback, useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import {FormHelperText, IconButton, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import {WORK_MODEL_TYPES} from "../optionEnums";
import {
    BONUS_MODEL,
    INDUSTRY_MODEL, JOB_CATEGORY_MODEL, JOB_FUNCTION,
    JOB_TYPE_MODEL, LEAVE_MODEL, SALARY_BAND_MODEL,
    WORK_MODEL,
    YES_NO_MODEL
} from "../selectEnums";
import Button from "@mui/material/Button";
import Enums from "../General/Enums";
import {editJobByClient, postJob, postJobByClient, putJob} from "../../utilities/HrAPI";
import keycloak from "../../Keycloak";
import {useNavigate} from "react-router-dom";
import {getJobById} from "../../utilities/cvAPI";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import Skills from "../CV/Steps/Skills";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import EditorState from "draft-js/lib/EditorState";
import { Editor } from 'react-draft-wysiwyg';
import {useClient} from "../../utilities/ClientProvider";
import GoogleMapsAutocomplete from "./GoogleMapsAutoComplete";
import {toast} from "react-toastify";
import dayjs from "dayjs";
import { convertToRaw, convertFromRaw } from 'draft-js';
import {showSaveSuccessMessage} from "../toastUtils";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {getClientByClient_Identity} from "../../utilities/ClientApi";

const JobsAdd = ({jobId, readOnly}) => {
    const navigate = useNavigate();
    const [hybridWorkModel, setHybridWorkModel] = useState(false);
    const [job, setJob] = useState(Enums.job)
    const [isEdit, setIsEdit] = useState(false)
    const [userSaved, setUserSaved] = useState(false);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [startDate, setStartDate] = useState(null);
    const [enableSave, setEnableSave] = useState(false);
    const [remoteWorkModel, setRemoteWorkModel] = useState(false);
    const [selectedClient, setSelectedClient] = useState('all');
    const [setClients] = useState([]);
    const {client,setClient } = useClient(); // Get the setClient function from context



    const handleEditorChange = (newState) => {
        setEditorState(newState);
        const content = newState.getCurrentContent(); // If you want plain text, otherwise convert it to the required format
        const rawContent = convertToRaw(content)
        const contentJson = JSON.stringify(rawContent)
        setJob((prev) => ({
            ...prev,
            jobDetails: {
                ...prev.jobDetails,
                rolesResponsibilities: contentJson,
            },
        }));

        setEnableSave(true)
    };

    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const showSaveFailure = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_LEFT,
            style: {
                backgroundColor: "#eb4335",
                width: "650px",
                color: "#FFFFFF",
                left: "500px",
                theme: "light",
            },
        });
    };

    const handleChange = useCallback((e) => {
        const {value, name} = e.target;
        setJob(prev => ({
            ...prev,
            [name]: value
        }));

        setEnableSave(true);
    }, []);

    const handleJobDetailsChange = useCallback((e) => {
        const { name, value } = e.target;
        //Show\Hide Hybrid Field
        if (name === "workModel") {
            setRemoteWorkModel(value === WORK_MODEL_TYPES.REMOTE.label);
            setHybridWorkModel(value === WORK_MODEL_TYPES.HYBRID.label);
        }
        setJob((prev) => ({
            ...prev,
            jobDetails: {
                ...prev.jobDetails,
                [name]: value,
            },
        }));

        setEnableSave(true);
    }, []);

    const handleSalaryChange = async (e) => {
        let {value, name} = e.target;
        setJob(prevJob => ({
            ...prevJob,
            salaryDetails: {
                ...prevJob.salaryDetails,
                [name]: value,
            },
        }));

        setEnableSave(true);
    }

    const handlePlaceSelected = (formattedLocation) => {
        handleJobDetailsChange({
            target: { name: 'jobPlacement', value: formattedLocation }
        });

        setEnableSave(true);
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
        setJob((prev) => ({
            ...prev,
            jobDetails: {
                ...prev.jobDetails,
                fromDate: date,
            },
        }));

        setEnableSave(true);
    };

    const handleEndDateChange = (date) => {
        setJob((prev) => ({
            ...prev,
            jobDetails: {
                ...prev.jobDetails,
                toDate: date,
            },
        }));

        setEnableSave(true);
    };

    const fetchClientListData = useCallback(async () => {
        if (keycloak && keycloak.token) {
            try {
                const clientInfo = await getClientByClient_Identity(keycloak.token);
                if (keycloak.hasResourceRole("system_admin")) {
                    const newViewStatus = [
                        {value: "all", label: "All"},
                        ...clientInfo.map(client => ({
                            value: client.clientId,
                            label: client.businessName
                        }))
                    ];
                    setClients(newViewStatus);
                    if (!selectedClient || selectedClient === "all") {
                        setClient(newViewStatus[0].value);
                    }
                } else if (keycloak.hasResourceRole("client_recruiter")
                    || keycloak.hasResourceRole("hr_admin")
                    || keycloak.hasResourceRole("client_user")
                    || keycloak.hasResourceRole("client_admin")
                    || keycloak.hasResourceRole("internal_user")
                    || keycloak.hasResourceRole("account_manager")
                    || keycloak.hasResourceRole("delivery_manager")) {
                    setClients([{value: clientInfo[0].clientId, label: clientInfo[0].businessName}]);
                    setClient(clientInfo[0].clientId);
                }
            } catch (e) {
                console.error("Error fetching job list data:", e);
            }
        }
    }, [setClient, setClients, selectedClient]);
    useEffect(() => {
        fetchClientListData();
    }, [fetchClientListData]);
    useEffect(() => {
        const sessionClient = sessionStorage.getItem("selected_client_id");
        if (sessionClient) {
            setSelectedClient(sessionClient);
        }
    }, []);
    const saveJob = () => {
        setUserSaved(true);
        setEnableSave(true);

        if (!validateJob()) {
            return;
        }

        const handleSaveSuccess = (message) => {
            navigate("/JobsList");
            showSaveSuccessMessage(message);
        };

        const handleSaveFailure = (message) => {
            showSaveFailure(message);
        };

        const handleSaveError = (error) => {
            console.log("Save job error:", error);
        };

        const isAdmin = keycloak.hasResourceRole("system_admin");

        if (isEdit) {

            if (isAdmin && client !== 'all') {
                editJobByClient(job, client, keycloak.token)
                    .then(() => handleSaveSuccess(`${job.jobTitle} has been successfully updated.`))
                    .catch(handleSaveError);
            } else if (isAdmin && selectedClient === 'all') {

                handleSaveFailure("Please select a client to assign this job to");
            } else {
                putJob(jobId, job, keycloak.token)
                    .then(() => handleSaveSuccess(`${job.jobTitle} has been successfully updated.`))
                    .catch(handleSaveError);
            }
        } else {
            if (isAdmin && client !== 'all') {
                postJobByClient(job, client, keycloak.token)
                    .then(() => handleSaveSuccess(`${job.jobTitle} has been successfully created.`))
                    .catch(handleSaveError);
            } else if (isAdmin && client === 'all') {
                console.log(client)
                handleSaveFailure("Please select a client to assign this job to");
            } else {
                postJob(job, keycloak.token)
                    .then(() => handleSaveSuccess(`${job.jobTitle} has been successfully created.`))
                    .catch(handleSaveError);
            }
        }
    };

    const getJob = useCallback(() => {
        if (jobId) {
            setIsEdit(true)
            getJobById(jobId)
                .then((job) => {
                    if (job) {
                        if (typeof job.jobDetails.jobPlacement === 'string') {
                            job.jobDetails.jobPlacement = job.jobDetails.jobPlacement.split(',');
                        }
                        setJob(job);
                        setRemoteWorkModel(job.jobDetails.workModel === WORK_MODEL_TYPES.REMOTE.value)
                        setHybridWorkModel(job.jobDetails.workModel === WORK_MODEL_TYPES.HYBRID.value)

                        const contentBlock = (job.jobDetails.rolesResponsibilities);
                        if (contentBlock) {
                            const contentState = convertFromRaw(JSON.parse(contentBlock));
                            const newEditorState = EditorState.createWithContent(contentState);
                            setEditorState(newEditorState);

                            console.log(contentState)
                        }
                    } else {
                        throw new Error();
                    }
                })
                .catch((e) => {
                    console.log(e)
                })
        }
    }, [jobId])

    useEffect(() => {
        getJob();
    }, [getJob]);

    const isJobPlacementValid = () => {
        return (Array.isArray(job?.jobDetails?.jobPlacement) && job.jobDetails.jobPlacement.length > 0) || remoteWorkModel;
    };

    const validateJob = () => {
        const requiredFields = ["jobTitle", "description", "workModel", "industry", "jobFunction"];
        for (let field of requiredFields) {
            if (!(job[field] || job?.jobDetails[field])) {
                console.log(`${field} is required.`);
                return false;
            }
        }
        if (hybridWorkModel && !job?.jobDetails?.hybridDays) {
            console.log("Hybrid days are required when hybrid work model is selected.");
            return false;
        }
        if (!job?.jobDetails.skills || job?.jobDetails.skills.length === 0) {
            console.log("Skills are required");
            return false;
        }
        return true;
    };

    const renderTextField = (id, label, value, onChange, extraProps = {}) => (
        <TextField
            key={id} // Ensure each component has a unique key
            sx={style}
            className="inputWidth"
            id={id}
            name={id}
            data-testid={id}
            style={{ pointerEvents: readOnly ? "none" : "auto" }}
            variant={readOnly ? "standard" : "outlined"}
            value={value}
            onChange={onChange}
            margin="normal"
            label={label}
            required={extraProps.required || false} // Ensure the required prop is passed correctly
            error={userSaved && !value} // Show error if the field is required and empty after user saves
            {...extraProps}
        />
    );

    const renderSelectField = (id, label, value, onChange, options, extraProps = {}) => (
        <TextField
            key={id} // Ensure each component has a unique key
            select
            sx={style}
            className="inputWidth"
            id={id}
            name={id}
            data-testid={id}
            style={{ pointerEvents: readOnly ? "none" : "auto" }}
            variant={readOnly ? "standard" : "outlined"}
            value={value}
            onChange={onChange}
            margin="normal"
            label={label}
            required={extraProps.required || false} // Ensure the required prop is passed correctly
            error={extraProps.required && userSaved && !value} // Show error if the field is required and empty after user saves
            {...extraProps}
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );

    const handleBackClick = () => {
        navigate(`/JobsList`)
    };

    return (
        <div data-testid="jobsAddContainer" style={{padding: "20px 5%"}}>
            <div className="row">
                <form onSubmit="" encType="multipart/form-data" method="POST">
                    <Grid container direction="column" justifyContent="flex-start" alignItems="stretch" spacing={2} className="gridPadding">
                        <Grid item xs={12} className={"d-inline-flex"}>
                            <IconButton hidden={!(isEdit && readOnly)}
                                className={"btn-primary-round me-3"}
                                data-testid={"job-view-navigate-back"}
                                onClick={handleBackClick}>
                                <ArrowBackIcon />
                            </IconButton>

                            <h1 hidden={isEdit} className="mb-3" data-testid="AddNewJobHeading">
                                Add a new Job Posting
                            </h1>
                            <h1 hidden={!(isEdit && !readOnly)} className="mb-3" data-testid="AddNewJobHeading">
                                Edit {job.jobTitle}
                            </h1>
                            <h1 hidden={!(isEdit && readOnly)} className="mb-3" data-testid="AddNewJobHeading">
                                View {job.jobTitle}
                            </h1>
                        </Grid>

                        <Box sx={{flexGrow: 1}} xs={12} className="box-formatting">
                            <Paper className="align-content-center h-auto cardWidth elevation1" elevation={1}>
                                <h2>Job Details</h2>
                                <Grid container direction="column" justifyContent="flex-start" alignItems="stretch"
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        {renderTextField("jobTitle", "Job Title", job.jobTitle, handleChange, { required: true })}
                                        {renderTextField("description", "Job Description", job.jobDetails.description, handleJobDetailsChange, { required: true, multiline: true, minRows: 4 })}
                                        <FormControl  sx={{
                                            width: '80%',
                                            marginTop: '16px',
                                            "& label.Mui-focused": {
                                                color: "#FF6600",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "#FF6600",
                                                },
                                            },
                                        }}>
                                            <InputLabel shrink sx={{ backgroundColor: '#fff', paddingRight: '4px',
                                                '&:hover': {
                                                    color: '#FF6600',
                                                }, }}>Roles and Responsibilities</InputLabel>
                                            <Box
                                                sx={{
                                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                                    padding: '16px 8px 8px',
                                                    borderRadius: '8px',
                                                    '&:hover': {
                                                        borderColor: '#FF6600',
                                                    },
                                                    "& .Mui-focused": {
                                                        borderColor: "#FF6600",
                                                    },
                                                }}
                                                data-testid="wysiwyg-editor"
                                            >
                                                <Editor
                                                    readOnly={readOnly}
                                                    editorState={editorState}
                                                    onEditorStateChange={handleEditorChange}
                                                    toolbarClassName="toolbarClassName"
                                                    wrapperClassName="wrapperClassName"
                                                    editorClassName="editorClassName"
                                                    toolbarHidden={readOnly}
                                                    toolbar={{
                                                        options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link'],
                                                    }}
                                                />
                                            </Box>
                                            {userSaved && !job?.jobDetails?.rolesResponsibilities && (
                                                <FormHelperText error>Roles and responsibilities is required.</FormHelperText>
                                            )}
                                        </FormControl>

                                        {renderSelectField("jobType", "Job Type", job?.jobDetails?.jobType, handleJobDetailsChange, JOB_TYPE_MODEL,{ required: true })}
                                        {renderSelectField("jobCategory", "Job Category", job?.jobDetails?.jobCategory, handleJobDetailsChange, JOB_CATEGORY_MODEL,{ required: true })}
                                        <Grid container spacing={2.5}>
                                            <Grid item xs={4.5}>

                                            </Grid>
                                            <Grid item xs={9.7}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Start Date"
                                                        sx={style}
                                                        format="DD/MM/YYYY"
                                                        value={job.jobDetails.fromDate === "" ? null : dayjs(job.jobDetails.fromDate)}
                                                        onChange={handleStartDateChange}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                required: true,
                                                                variant: readOnly ? "standard" : "outlined",
                                                                inputProps: {"data-testid": "date-from"}
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={9.7}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Expiry Date"
                                                        sx={style}
                                                        format="DD/MM/YYYY"
                                                        onChange={handleEndDateChange}
                                                        minDate={startDate}
                                                        value={job.jobDetails.toDate === "" ? null : dayjs(job.jobDetails.toDate)}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                required: true,
                                                                variant: readOnly ? "standard" : "outlined",
                                                                inputProps: {"data-testid": "date-to"}
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={4}>

                                            </Grid>
                                        </Grid>
                                        {renderSelectField("workModel", "Working Model", job?.jobDetails?.workModel, handleJobDetailsChange, WORK_MODEL, { required: true })}
                                        {renderTextField("hybridDays", "Hybrid number of days", job?.jobDetails?.hybridDays, handleJobDetailsChange, { required: hybridWorkModel, className: hybridWorkModel ? 'd-block inputWidth' : 'd-none inputWidth' })}
                                        <FormControl hidden={remoteWorkModel} sx={style} className="inputWidth" required margin="normal"
                                                     error={userSaved && !isJobPlacementValid()} >
                                            <GoogleMapsAutocomplete
                                                label="Job Placement Area"
                                                value={job?.jobDetails?.jobPlacement || []}
                                                onPlaceSelected={handlePlaceSelected}
                                                readOnly={readOnly}
                                                isValid={userSaved ? isJobPlacementValid() : true}
                                            />
                                            {userSaved && !isJobPlacementValid() && (
                                                <FormHelperText>Job Placement Area is required.</FormHelperText>
                                            )}
                                        </FormControl>
                                        {renderSelectField("industry", "Industry", job?.jobDetails?.industry, handleJobDetailsChange, INDUSTRY_MODEL, { required: true })}
                                        {renderSelectField("jobFunction", "Job Function", job?.jobDetails?.jobFunction, handleJobDetailsChange, JOB_FUNCTION, { required: true })}
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Paper className="h-auto cardWidth" elevation={2} style={{pointerEvents: readOnly ? "none" : true}}>
                                <Skills
                                    skills={job?.jobDetails?.skills || []}
                                    updateCV={(field, value) =>
                                        setJob(prev => ({
                                            ...prev,
                                            jobDetails: {
                                                ...prev.jobDetails,
                                                [field]: value,
                                            }
                                        }))
                                    }
                                    userHasClickedNext={userSaved}
                                    readOnly={readOnly}
                                />
                            </Paper>

                            <Paper className="h-auto cardWidth" elevation={2}>
                                <h2> Salary and benefits </h2>
                                <Grid container direction="column" justifyContent="flex-start" alignItems="stretch"
                                      spacing={2} padding={5} className="ParagraphPadding">
                                    <Grid item xs={12}>
                                        {renderSelectField("salaryBand", "Salary band", job?.salaryDetails?.salaryBand, handleSalaryChange, SALARY_BAND_MODEL)}
                                        {renderSelectField("medicalAid", "Medical aid", job?.salaryDetails?.medicalAid, handleSalaryChange, YES_NO_MODEL)}
                                        {renderSelectField("leave", "Leave", job?.salaryDetails?.leave, handleSalaryChange, LEAVE_MODEL)}
                                        {renderSelectField("bonus", "Bonus", job?.salaryDetails?.bonus, handleSalaryChange, BONUS_MODEL)}
                                        {renderSelectField("lifeAndDisabilityInsurance", "Life and disability insurance", job?.salaryDetails?.lifeAndDisabilityInsurance, handleSalaryChange, YES_NO_MODEL)}
                                        {renderSelectField("pension", "Pension", job?.salaryDetails?.pension, handleSalaryChange, YES_NO_MODEL)}
                                        {renderSelectField("trainingBudget", "Training Budget", job?.salaryDetails?.trainingBudget, handleSalaryChange, YES_NO_MODEL)}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>

                        <Box xs={12} className="cardWidth" sx={{marginTop: '5%', marginBottom: '5%', width: '90%'}}>
                            <Grid container direction="row" spacing={2} justifyContent="flex-start"
                                  alignContent="center">
                                <div style={{float: "right", marginLeft: 'auto'}}>
                                    <Button data-testid="btn-save"
                                            hidden={readOnly}
                                            className={"btn btn-primary-custom text-end ms-3"}
                                            onClick={saveJob}
                                            disabled={!enableSave}
                                            style={{
                                                float: "right",
                                            }}>
                                        Save
                                    </Button>
                                    <Button data-testid="btn-cancel"
                                            href="JobsList"
                                            hidden={readOnly}
                                            variant="outlined"
                                            className={"btn btn-secondary-custom text-end"}
                                            style={{
                                                float: "right"
                                            }}>
                                        Cancel
                                    </Button>
                                </div>
                            </Grid>
                        </Box>
                    </Grid>
                </form>
            </div>
        </div>
    )
}

export default JobsAdd;